import React, { Component } from 'react';
// import { Link } from 'react-router-dom'


import "./ArchiveIceberg.css"

export default class ArchiveIceberg extends Component {


  render () {

    return (
      <div className="ArchiveIceberg">
        <p>Date  - Placeholder for Icebergs</p>
      </div>
    )
  }
    
}

